/**
 * Excerpt Toggle
 * Gère le système "Voir plus" / "Voir moins" de la description produit
 */

class ExcerptToggle {
  constructor(container) {
    this.container = container;
    this.button = container.querySelector('[data-see-more]');
    this.shortText = container.querySelector('[data-excerpt-text]');
    this.fullText = container.querySelector('[data-excerpt-full]');
    this.isExpanded = false;

    // Get translations from data attributes (fallback to French)
    this.seeMoreText = this.button?.dataset.seeMoreText || 'Voir plus';
    this.seeLessText = this.button?.dataset.seeLessText || 'Voir moins';

    this.init();
  }

  init() {
    if (!this.button || !this.shortText || !this.fullText) return;

    this.button.addEventListener('click', () => {
      this.toggle();
    });
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      // Afficher le texte complet
      this.shortText.style.display = 'none';
      this.fullText.classList.add('is-visible');
      this.button.textContent = this.seeLessText;
    } else {
      // Afficher le texte court
      this.fullText.classList.remove('is-visible');
      this.shortText.style.display = 'inline';
      this.button.textContent = this.seeMoreText;
    }
  }
}

/**
 * Initialisation automatique au chargement
 */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initExcerptToggles);
} else {
  initExcerptToggles();
}

function initExcerptToggles() {
  const excerpts = document.querySelectorAll('[data-excerpt]');
  excerpts.forEach((excerpt) => {
    new ExcerptToggle(excerpt);
  });
}
